<template>
  <div style="height: 300px; overflow: auto" class="table-responsive">
    <!-------------------- Tabla de REsultados -------------------->
    <table class="table table-invoice table-hover">
      <thead>
        <tr>
          <th scope="col">Producto</th>
          <th>opciones</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="det in data" v-bind:key="det.id">
          <td>{{ det.producto_obj.sku }} - {{ det.producto_obj.nombre }}</td>
          <td>
            <button
              type="button"
              @click="DeleteProductoProveedor(det.id)"
              class="btn btn-sm btn-danger"
            >
              Eliminar
            </button>
          </td>
        </tr>
        <tr></tr>
      </tbody>
    </table>
    <!-------------------- END - Basic Table -------------------->
  </div>
</template>
<script>
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";

export default {
  props: ["data", "current"],
  data() {
    return {};
  },
  mounted() {},
  methods: {
    DeleteProductoProveedor(producto_id) {
      let self = this;
      DynamicService.delete("cat", "producto-proveedor", producto_id)
        .then((response) => {
          Notifications.alert.success("Eliminar", "Realizado Correctamente");
          this.$emit("refreshProductoProveedor");
          self.refreshProductoProveedor(this.$route.params.id);
        })
        .catch((errors) => {
        });
    },
  },
};
</script>